import {createRouter, createWebHashHistory} from 'vue-router'
import {useRouterStore} from "@/stores/router.js";
import {isNotEmptyString, removeLocalStorage, setLocalStorage} from "@/assets/js/commonUtil.js";
import {useCommonInfoStore} from "@/stores/commonInfoStore.js";

const getRouterStore = () => {
    return useRouterStore();
}

const getCommonInfoStore = () => {
    return useCommonInfoStore();
}

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/detectionDetail',
            name: 'detectionDetail',
            component: () => import('@/views/report/detectionDetail.vue'),
            meta: {
                title: "我的报告",
                content: '我的报告'
            }
        },
        {
            path: '/classification',
            name: 'classification',
            component: () => import('@/views/report/classification.vue'),
            meta: {
                title: "我的报告",
                content: '我的报告'
            }
        },
        {
            path: '/previewReport',
            name: 'previewReport',
            component: () => import('@/views/report/previewReport.vue'),
            meta: {
                title: "我的报告",
                content: '我的报告'
            }
        },
        {
            path: '/classificationPreview',
            name: 'classificationPreview',
            component: () => import('@/views/report/classificationPreview.vue'),
            meta: {
                title: "我的报告",
                content: '我的报告'
            }
        },
        {
            path: '/detectionDetailPreview',
            name: 'detectionDetailPreview',
            component: () => import('@/views/report/detectionDetailPreview.vue'),
            meta: {
                title: "我的报告",
                content: '我的报告'
            }
        },
        {
            path: '/cancerReportCollect',
            name: 'cancerReportCollect',
            component: () => import('@/views/jiyin_report/cancerReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/geneticReportCollect',
            name: 'geneticReportCollect',
            component: () => import('@/views/jiyin_report/geneticReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/nutritureReportCollect',
            name: 'nutritureReportCollect',
            component: () => import('@/views/jiyin_report/nutritureReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/psychologicReportCollect',
            name: 'psychologicReportCollect',
            component: () => import('@/views/jiyin_report/psychologicReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/healthyLifeReportCollect',
            name: 'healthyLifeReportCollect',
            component: () => import('@/views/jiyin_report/healthyLifeReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/cancerReportDetails',
            name: 'cancerReportDetails',
            component: () => import('@/views/jiyin_report_details/cancerReportDetails.vue'),
            meta: {
                title: "报告详情",
                content: '报告详情'
            }
        },
        {
            path: '/nutritureReportDetails',
            name: 'nutritureReportDetails',
            component: () => import('@/views/jiyin_report_details/nutritureReportDetails.vue'),
            meta: {
                title: "营养状况详情",
                content: '营养状况详情'
            }
        },
        {
            path: '/psychologicReportDetails',
            name: 'psychologicReportDetails',
            component: () => import('@/views/jiyin_report_details/psychologicReportDetails.vue'),
            meta: {
                title: "心理情况详情",
                content: '心理情况详情'
            }
        },
        {
            path: '/geneticReportDetails',
            name: 'geneticReportDetails',
            component: () => import('@/views/jiyin_report_details/geneticReportDetails.vue'),
            meta: {
                title: "遗传病风险详情",
                content: '遗传病风险详情'
            }
        },
        {
            path: '/healthyLifeReportDetails',
            name: 'healthyLifeReportDetails',
            component: () => import('@/views/jiyin_report_details/healthyLifeReportDetails.vue'),
            meta: {
                title: "健康生活方式详情",
                content: '健康生活方式详情'
            }
        },
        {
            path: '/questionnaireRedirect',
            name: 'questionnaireRedirect',
            component: () => import('@/views/questionnaireRedirect.vue'),
            meta: {
                title: "健康咨询",
                content: '健康咨询'
            }
        },
        {
            path: '/questionnaire',
            name: 'questionnaire',
            component: () => import('@/views/questionnaire.vue'),
            meta: {
                title: "健康咨询",
                content: '健康咨询'
            }
        },
        {
            path: '/execeptionClause',
            name: 'execeptionClause',
            component: () => import('@/views/execeptionClause.vue'),
            meta: {
                title: "免责条款",
                content: '免责条款'
            }
        },
        {
            path: '/shotCancerReportCollect',
            name: 'shotCancerReportCollect',
            component: () => import('@/views/screenshot/shotCancerReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/shotGeneticReportCollect',
            name: 'shotGeneticReportCollect',
            component: () => import('@/views/screenshot/shotGeneticReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/shotNutritureReportCollect',
            name: 'shotNutritureReportCollect',
            component: () => import('@/views/screenshot/shotNutritureReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/shotPsychologicReportCollect',
            name: 'shotPsychologicReportCollect',
            component: () => import('@/views/screenshot/shotPsychologicReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/shotHealthyLifeReportCollect',
            name: 'shotHealthyLifeReportCollect',
            component: () => import('@/views/screenshot/shotHealthyLifeReportCollect.vue'),
            meta: {
                title: "检测报告",
                content: '检测报告'
            }
        },
        {
            path: '/shotGeneticReportDetails',
            name: 'shotGeneticReportDetails',
            component: () => import('@/views/screenshot/shotGeneticReportDetails.vue'),
            meta: {
                title: "遗传病详情页",
                content: '遗传病详情页'
            }
        },
        {
            path: '/shotGeneticReportClassify',
            name: 'shotGeneticReportClassify',
            component: () => import('@/views/screenshot/shotGeneticReportClassify.vue'),
            meta: {
                title: "遗传病详情整合页",
                content: '遗传病详情整合页'
            }
        },
        {
            path: '/shotCancerReportClassify',
            name: 'shotCancerReportClassify',
            component: () => import('@/views/screenshot/shotCancerReportClassify.vue'),
            meta: {
                title: "肿瘤详情整合页",
                content: '肿瘤详情整合页'
            }
        }
    ]
})

/* 全局路由守卫 */
router.beforeEach((to, from, next) => {
    // 判断是否是第一次访问应用
    if (!from || from.fullPath === '/') {
        const token = to.query.token;
        if (isNotEmptyString(token)) {
            //存入缓存
            setLocalStorage('huaxiHealthToken', decodeURIComponent(token));
        } else {
            removeLocalStorage('huaxiHealthToken');
        }

        // 处理客户端来源参数
        try {
            const commonInfoStore = getCommonInfoStore();
            if (isNotEmptyString(to.query.client) && commonInfoStore) {
                commonInfoStore.setAccessSourceValue(to.query.client);
            }
        } catch (error) {
            console.error('设置客户端来源失败:', error);
        }

        // 记录路由历史
        try {
            const routerStore = getRouterStore();
            if (routerStore) {
                routerStore.pushRouterHistoryStack(to);
            }
        } catch (error) {
            console.error('记录路由历史失败:', error);
        }
    }

    // 设置页面标题
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    next();
})

export default router
